import {commonControllers} from '@mintdata-wsp/common/controllers/CommonControllers';
import {IMeshContext} from '@mintdata-wsp/common/controllers/spreadsheet/mesh/contexts/MeshContext';
import {SheetController} from '@mintdata-wsp/common/controllers/spreadsheet/SheetController';
import {SheetSettingsController} from '@mintdata-wsp/common/controllers/spreadsheet/SheetSettingsController';
import {SheetId, WorkbookId} from '@mintdata/mint-kit/api/models/Identifiers';

export class MeshContextImpl implements IMeshContext
{
    public readonly workbookId:WorkbookId;
    public readonly mainSheetId:SheetId;
    public readonly sheetId:SheetId;
    public readonly isNested:boolean;
    public readonly sheetCtrl:SheetController;
    public readonly sheetSettingsCtrl:SheetSettingsController;

    public constructor(workbookId:WorkbookId, mainSheetId:SheetId, sheetId:SheetId, isNested:boolean)
    {
        this.workbookId = workbookId;
        this.mainSheetId = mainSheetId;
        this.sheetId = sheetId;
        this.isNested = isNested;
        this.sheetCtrl = commonControllers.spreadsheets.sheet;
        this.sheetSettingsCtrl = commonControllers.spreadsheets.sheetSettings;
    }
}
